import { render, staticRenderFns } from "./RequisicionesModal.vue?vue&type=template&id=03f804c5&"
import script from "./RequisicionesModal.vue?vue&type=script&lang=js&"
export * from "./RequisicionesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports